// extracted by mini-css-extract-plugin
export var defaultRatioClass = "video-post-preview-module--default-ratio-class--87ddc";
export var header = "video-post-preview-module--header--cedd2";
export var image = "video-post-preview-module--image--7ae3d";
export var imageWrapper = "video-post-preview-module--imageWrapper--8738f";
export var playButton = "video-post-preview-module--playButton--4231c";
export var videoButton = "video-post-preview-module--videoButton--2976d";